export enum EXPLANATION_TYPES {
  TEXT = 'text',
  VIDEO = 'video'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/explanation-type/explanation-types.ts